import { ref } from 'vue';

interface ModalControls {
  open: () => void;
  close: () => void;
}

const modalRegistry = ref<Map<string, ModalControls>>(new Map());

export function registerModal(id: string, controls: ModalControls) {
  modalRegistry.value.set(id, controls);

  return () => {
    modalRegistry.value.delete(id);
  };
}

export function useModal(id: string) {
  function open() {
    const modal = modalRegistry.value.get(id);
    if (modal) {
      modal.open();
    } else {
      console.warn(`Modal with id "${id}" not found in registry`);
    }
  }

  function close() {
    const modal = modalRegistry.value.get(id);
    if (modal) {
      modal.close();
    }
  }

  return { open, close };
}
